<template>
  <div
    class="column has-text-centered opportunity-item"
    :style="{ color: visitIsActive ? 'black' : '#d1d1d1' }"
  >
    <b-icon
      icon="bus-alt"
      :style="{ color: visitIsActive ? 'black' : '#d1d1d1' }"
    ></b-icon>
    <br />

    <span>Visita</span>
  </div>
</template>

<script>
export default {
  props: ["visitIsActive"]
};
</script>

<style scoped>
div {
  font-size: 1rem;
}
</style>
